const customVideoFormat = /\.(?:mp4|mov)(?:[/?#]|$)/i;

export const isCustomVideoFormat = (url: string): boolean => {
	return customVideoFormat.test(url);
};
